<template>
  <div>
    <Form ref="item" id="lyform" :model="item" :show-message="false" :label-width="labelWidth ? labelWidth : 80"
      :style="{ height: height ? height + 'px' : 'auto' }">
      <ul id="caculate">
        <li :class="{ active: selectName == x }" v-for="x in fffff" :key="x" @click="selectItem(x)">
          {{ x }}
        </li>
      </ul>

      <Row :gutter="16">


        <Col :span="x.span ? x.span : 8" v-for="(x, index) in forms" :key="index"
          v-show="fenlei != undefined ? x.fenlei == selectName : true">
        <FormItem :class="{ hideLabel: x.hideLabel }" :label="x.title" :prop="x.key1 ? x.key1 : x.key">
          <Table v-if="x.type == 'table'" border :columns="itemListForms" :data="item.itemList"></Table>
          <Input v-if="x.type == 'Input'" v-model="item[x.key]" :placeholder="x.placeholder || '请输入'" :type="x.type1"
            :rows="x.rows" :readonly="x.readonly" :disabled="x.disabled" :clearable="x.clearable"
            :maxlength="x.maxlength" :show-word-limit="x.showWordLimit"></Input>
          <slot v-if="x.slotForm" :name="x.slotForm"></slot>
          <InputNumber v-if="x.type == 'InputNumber'" v-model="item[x.key]" :min="x.min" :max="x.max"
            :readonly="x.readonly" :disabled="x.disabled" :clearable="x.clearable" style="width: 100%"></InputNumber>
         
           
            <i-switch v-model="item[x.key]" v-if="x.type == 'bool'">
              <span slot="open">{{ $t("bool.true") }}</span>
              <span slot="close">{{ $t("bool.false") }}</span>
            </i-switch>
            <RadioGroup v-model="item[x.key]" v-if="x.type == 'bool1'">
              <Radio :label="0">{{ $t("bool.false") }}</Radio>
              <Radio :label="1">{{ $t("bool.true") }}</Radio>
            </RadioGroup>
            <selectCar v-if="x.type == 'selectCar'" :name="item[x.key1]" @update:name="item[x.key1] = $event"
              :id="item[x.key]" @update:id="item[x.key] = $event" @car="$emit('car', $event, x.key, index)">
            </selectCar>

            <selectGroup v-if="x.type == 'selectGroup'" :name="item[x.key1]" @update:name="item[x.key1] = $event"
              :id="item[x.key]" @update:id="item[x.key] = $event">
            </selectGroup>
            <selectAddMap v-if="x.type == 'selectAddMap'" :address="item[x.key]" @update:address="item[x.key] = $event"
              :lng="item[x.keyX]" @update:lng="item[x.keyX] = $event" :lat="item[x.keyY]"
              @update:lat="item[x.keyY] = $event" :type="item[x.keyType]" @update:type="item[x.keyType] = $event"
              :readonly="x.readonly" :list1="x.list1" :list2="x.list2">
            </selectAddMap>
            <AddressList :list="item[x.key]" :list1="x.list1" :list2="x.list2" v-if="x.type == 'AddressList'"
              @update:list="item[x.key] = $event" :noUpdate="x.noUpdate" :readonly="x.readonly"></AddressList>
            <selectUser v-if="x.type == 'selectUser'" :name="item[x.key1]" @update:name="item[x.key1] = $event"
              :account="item[x.key3]" @update:account="item[x.key3] = $event" :accountId="item[x.key4]"
              @update:accountId="item[x.key4] = $event" :id="item[x.key]" @update:id="item[x.key] = $event"
              :keyword="x.keyword">
            </selectUser>
            <selectFlow v-if="x.type == 'selectFlow'" v-model="item[x.key]"></selectFlow>
            <lyyymmdd v-if="x.type == 'lyyymmdd'" :formate="x.formate" :clearable="x.clearable" v-model="item[x.key]">
            </lyyymmdd>
            <ly-photo :readonly="true" v-if="x.type == 'lyPhoto'" ref="lyphoto" v-model="item[x.key]" :one="x.one"></ly-photo>

            <Select v-model="item[x.key]" style="width: 100%" v-if="x.type == 'Select'" :multiple="x.multiple"
              :readonly="x.readonly" :disabled="x.disabled" :filterable="x.filterable" :allow-create="x.allowCreate"
              @on-create="handleCreate1($event, x)" :clearable="x.clearable">
              <Avatar :src="'static/' +
      find(x.selectItems, 'id', item[x.key], 'icon') +
      '/4/3.gif'
      " slot="prefix" size="small" v-if="x.icon" />
              <Option :value="x.selectType == 'obj' ? y.id : y" v-for="(y, index1) in x.selectItems" :key="index1"
                :label="x.selectType == 'obj' ? y.name : y">
                <img :src="'static/' + y.icon + '/4/3.gif'" width="26"
                  style="float: left; margin-top: -6px; margin-right: 10px" v-if="x.icon" />
                <span>{{ x.selectType == "obj" ? y.name : y }}</span>
              </Option>
            </Select>
            <Select style="width: 100%" v-model="item[x.key]" v-if="x.type == 'Select1'">
              <Option v-for="(y, index1) in $t(x.st)" :value="index1" :key="index1">{{ x.selectType == "obj" ? y.name :
      y
                }}</Option>
            </Select>
            <selectPerson v-if="x.type == 'selectPerson'" :name="item[x.key1]" @update:name="item[x.key1] = $event"
              :id="item[x.key]" @update:id="item[x.key] = $event">
            </selectPerson>
            <selectDriver v-if="x.type == 'selectDriver'" :name="item[x.key1]" @update:name="item[x.key1] = $event"
              :id="item[x.key]" @update:id="item[x.key] = $event">
            </selectDriver>
            <ColorPicker v-model="item[x.key]" v-if="x.type == 'color'" />
        </FormItem>
        </Col>
      </Row>
    </Form>
    <slot name="content"></slot>
    <Tag color="red">以下信息属于负责人签字</Tag>
    <Table :data="tableData" :columns="columns">
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" :disabled="readonly" @click="del(row)">删除</Button>
      </template>
    </Table>
  </div>
</template>
<script>
import fields from "./fields"

export default {
  name: "docDetail",
  props: ["fenlei", "height", "labelWidth","readonly"],
  data() {
    return {
      item: {},
      fffff: [],
      forms: [],
      searchItem: {
        id: "",
      },
      columns: [
        {
          title: "职务",
          key: "role",
        },
        {
          title: "姓名",
          key: "name",
        },
        {
          title: "时间",
          key: "signTime2",
        },
        {
          title: "签字意见",
          key: "comment",
        },
        {
          title: "操作",
          slot: "action",
        },
      ],
      tableData: [],
      config: {
        'fukuanshenqing': {
          url: '/cloud-tms-server-fms/paymentApply/info',
        },
        'baoxiaoshenqing': {
          url: '/cloud-tms-server-fms/bxApply/info',
        },
      },
      itemListForms: [
        {
          title: "报销用途",
          key: "reason",
        },
        {
          title: "金额",
          key: "money",
        },
      ]
    };
  },
  methods: {
    reach(v) {
      console.log(v);
      this.formId = v.formId;
      //formId
      var ff = [{
        title: "流水号",
        key: "no",
        type: "Input",
      }];
      this.forms = [...ff, ...fields[this.formId]]; //xianxiesi

      this.searchItem.id = v.docId;
      this.getDetail();
    },
    getDetail() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + this.config[this.formId].url,
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        if (res) {
          var data = res.data.data;
          console.log(res);
          //console.log(data);
          if (data != null) {
            data.filesPathArr = this.utils.isEmpty(data.imgPaths)
            ? []
            : JSON.parse(data.imgPaths);
            this.item = data;
            
            var dd = data.approveCommentList;
            for (let i = 0; i < dd.length; i++) {
              dd[i].signTime2 = this.utils.time(dd[i].signTime, 'yymmdd');
            }
            this.tableData = dd;

          }
        }
      });
    },
    //删除签名
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.ipPort + "/cloud-tms-server-fms/approveComment/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getDetail();
            }
          });
        },
      });
    },
  },
};
</script>
<style>
#secsldg {
  width: 100%;
}

#secsldg td {
  width: 25%;
  padding: 6px 6px;
}

#secsldg thead tr {
  background: #f1f8fd;
}
</style>


// WEBPACK FOOTER //
// src/components/wuliu/caiwufeiyong/docDetail.vue